export default
{

    data()
    {
        return {
            activeSublistIndex: -1,

            activeSubFilterIndex: 0,

            filters:
            [
                {
                    "title": this.$root.trads[5],
                    "isActive": true,
                    "slug": "projects",
                    "color": this.$root.color[0],
                    "subfilters": []
                },
                {
                    "title": this.$root.trads[31],
                    "isActive": true,
                    "slug": "article",
                    "color": this.$root.color[1],
                    "subfilters": []
                },
                {
                    "title": this.$root.trads[32],
                    "isActive": true,
                    "slug": "medias",
                    "color": this.$root.color[2],
                    "subfilters": []
                },
                {
                    "title": this.$root.trads[30],
                    "isActive": true,
                    "slug": "team",
                    "color": this.$root.color[3],
                    "subfilters":
                    [
                        {
                            "cat_name": this.$root.trads[48],
                            "type": "router-link",
                            "slug": "/philosophy",
                            "isActive": true,
                            "count": 'none'
                        },
                        {
                            "cat_name": this.$root.trads[33],
                            "type": "router-link",
                            "slug": "/team",
                            "count": 0,
                            "isActive": true
                        },
                        {
                            "cat_name": "Clients",
                            "type": "router-link",
                            "slug": "/clients",
                            "isActive": true,
                            "count": ''
                        }
                    ]
                }
            ]
        }
    },

    created()
    {

        this._uniqueCatActive = ''
        this._uniqueSubcatActive = ''

        this._article = 'article=',
        this._projects = 'projects=',
        this._medias = 'medias=',
        this._team = 'team=',
        this._instagram = 'instagram='


        this._dataSrc = ''

        this.eventHub.$on('display:cat', this.onDisplayCat)
        this.eventHub.$on('display:subcat', this.onDisplaySubcat)
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('filters:reset', this.onResetFilters)
    },

    mounted()
    {
        const subFilterInstagram =
        {
            "cat_name": 'Instagram',
            "slug": "instagram",
            "count": this.$root.globalContent.categories['instagram'],
            "isActive": true
        }

        const filterAgency =
        {
            "cat_name": this.$root.trads[50],
            "slug": 'agency',
            'count': this.$root.globalContent.categories['agency'],
            'isActive': true
        }

        this.$items = this.$el.querySelectorAll('.js-item')
        this.$sublist = this.$el.querySelectorAll('.js-sublist')

        this.filters[0].subfilters = this.sortFilters(this.$root.globalContent.categories['projects'])
        this.filters[1].subfilters = this.sortFilters(this.$root.globalContent.categories['articles'])
        this.filters[2].subfilters = this.sortFilters(this.$root.globalContent.categories['medias'])

        this.filters[3].subfilters[1].count = this.$root.globalContent.categories['team']
        this.filters[3].subfilters[2].count = this.$root.globalContent.categories['clients']

        for(let i = 0; i < this.filters.length - 1; i++)
        {
            this.filters[i].subfilters.sort((a, b) =>
            {
                return a.order - b.order
            })
        }

        this.filters[3].subfilters.push(filterAgency)

        this.filters[2].subfilters.unshift(subFilterInstagram)


        this.$nextTick(() =>
        {
            this.onResize()
        })
    },

    destroyed()
    {
        this.eventHub.$off('display:cat', this.onDisplayCat)
        this.eventHub.$off('display:subcat', this.onDisplaySubcat)
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('filters:reset', this.onResetFilters)
    },

    methods:
    {
        onResize()
        {
            if(!this.$root.isSmallScreen)
            {
                let translation = 0

                for(let i = this.$items.length - 1; i >= 0; i--)
                {
                    translation += this.$items[i].offsetHeight - 30

                    this.$items[i].style.top = translation + 'px'
                }
            }
            else
            {
                for(let i = 0; i < this.$items.length; i++)
                {
                    this.$items[i].style.height = 30 + 'px'
                }

                this.closeAllSublist()
            }
        },

        onDisplayCat(cat)
        {
            if(this._uniqueCatActive === cat)
            {
                return
            }

            this._uniqueCatActive = cat

            let index = -1

            if(cat === 'projects')
            {
                index = 0
                this._medias = ''
                this._article = ''
                this._team = ''
                this._instagram = ''
                this._agency = ''

                this.initProjects()
            }

            if(cat === 'article')
            {
                index = 1

                this._medias = ''
                this._projects = ''
                this._team = ''
                this._instagram = ''
                this._agency = ''

                this.initArticles()
            }

            if(cat === 'medias')
            {
                index = 2

                this._article = ''
                this._projects = ''
                this._team = ''
                this._instagram = ''
                this._agency = ''

                this.initMedias()
            }

            if(cat === 'instagram')
            {
                index = 2

                this._medias = ''
                this._article = ''
                this._projects = ''
                this._team = ''
                this._agency = ''

                this.initInstagram()
            }

            if(cat === 'team')
            {
                index = 3

                this._article = ''
                this._projects = ''
                this._medias = ''
                this._instagram = ''

                this.initTeam()
                this.initAgency()
            }

            for(let i = 0; i < this.filters.length; i++)
            {
                this.filters[i].isActive = false

                for(let j = 0; j < this.filters[i].subfilters.length; j++)
                {
                    this.filters[i].subfilters[j].isActive = false
                }
            }

            this.filters[index].isActive = true

            for(let i = 0; i < this.filters[index].subfilters.length; i++)
            {
                this.filters[index].subfilters[i].isActive = true
            }

            this.updateSrc(cat)
        },

        onDisplaySubcat(subcat, cat, auto = false)
        {
            if(this._uniqueSubcatActive === subcat && !auto)
            {
                return
            }

            this._uniqueCatActive = ''

            this._uniqueSubcatActive = subcat

            let filterIndex = 0
            let subfilterIndex = 0

            if(cat === 'projects')
            {
                filterIndex = 0
            }

            if(cat === 'article')
            {
                filterIndex = 1
            }

            if(cat === 'medias')
            {
                filterIndex = 2
            }

            if(cat === 'instagram')
            {
                filterIndex = 2
            }

            if(cat === 'team')
            {
                filterIndex = 3
            }

            for(let i = 0; i < this.filters.length; i++)
            {
                this.filters[i].isActive = false

                for(let j = 0; j < this.filters[i].subfilters.length; j++)
                {
                    this.filters[i].subfilters[j].isActive = false
                }
            }

            for(let i = 0; i < this.filters[filterIndex].subfilters.length; i++)
            {
                if(this.filters[filterIndex].subfilters[i].slug === subcat)
                {
                    subfilterIndex = i
                }
            }

            this.filters[filterIndex].isActive = true
            this.filters[filterIndex].subfilters[subfilterIndex].isActive = true

            if(subcat === 'instagram')
            {
                this._medias = ''
                this._article = ''
                this._projects = ''
                this._team = ''
                this._agency = ''

                this.initInstagram()
            }

            if(cat === 'projects')
            {
                this._medias = ''
                this._article = ''
                this._team = ''
                this._instagram = ''
                this._projects = 'projects=' + subcat
                this._agency = ''
            }

            if(cat === 'medias' && subcat !== 'instagram')
            {
                this._medias = 'medias=' + subcat
                this._article = ''
                this._team = ''
                this._instagram = ''
                this._projects = ''
                this._agency = ''
            }

            if(cat === 'article')
            {
                this._medias = ''
                this._article = 'article=' + subcat
                this._team = ''
                this._instagram = ''
                this._projects = ''
                this._agency = ''
            }

            if(subcat === 'agency')
            {
                this._team = ''
                this._medias = ''
                this._article = ''
                this._instagram = ''
                this._projects = ''

                this.initAgency()
            }

            if(subcat === 'all')
            {
                this._uniqueCatActive = ''

                for(let i = 0; i < this.filters[filterIndex].subfilters.length; i++)
                {
                    this.filters[filterIndex].subfilters[i].isActive = true
                }

                if(cat === 'team')
                {
                    this.initTeam()
                }

                if(cat === 'projects')
                {
                    this.initProjects()
                }

                if(cat === 'article')
                {
                    this.initArticles()
                }

                if(cat === 'medias')
                {
                    this.initMedias()
                }
            }

            this.updateSrc(cat)

            if(this.$route.name !== 'home')
            {
                this.$router.push('/')
            }
            else
            {
                this.eventHub.$emit('toggle:mobileNav')
            }
        },

        onResetFilters()
        {
            for(let i = 0; i < this.filters.length; i++)
            {
                this.filters[i].isActive = true

                for(let j = 0; j < this.filters[i].subfilters.length; j++)
                {
                    this.filters[i].subfilters[j].isActive = true
                }
            }

            this._uniqueCatActive = ''
            this._uniqueSubcatActive = ''

            this.initSrc()
            this.updateSrc()
            this.closeAllSublist()
        },

        initSrc()
        {
            this.initProjects()
            this.initArticles()
            this.initMedias()
            this.initTeam()
            this.initAgency()
        },

        initProjects()
        {
            this._projects = 'projects='

            for(let i = 0; i < this.filters[0].subfilters.length; i++)
            {
                this._projects += this.filters[0].subfilters[i].slug + '/'
            }
        },

        initArticles()
        {
            this._article = 'article='

            for(let i = 0; i < this.filters[1].subfilters.length; i++)
            {
                this._article += this.filters[1].subfilters[i].slug + '/'
            }
        },

        initMedias()
        {
            this._medias = 'medias='
            this._instagram = 'instagram='

            for(let i = 0; i < this.filters[2].subfilters.length; i++)
            {
                this._medias += this.filters[2].subfilters[i].slug + '/'
            }
        },

        initTeam()
        {
            this._team = 'team='
        },

        initInstagram()
        {
            this._instagram = 'instagram='
        },

        initAgency()
        {
            this._agency = 'agency='
        },

        updateSrc(cat)
        {
            let tmpDataSrc = '/home?' + this._projects + '&' + this._article + '&' + this._medias + '&' + this._team + '&' + this._instagram + '&' + this._agency

            tmpDataSrc = tmpDataSrc.replace(/\/&/g, '&')

            this._dataSrc = tmpDataSrc.replace(/&{2}/g, '&')
            this.eventHub.$emit('home:filter', this._dataSrc, cat)
        },

        closeAllSublist()
        {
            this.activeSublistIndex = -1

            if(!this.$root.isSmallScreen)
            {
                for(let i = 0; i < this.$items.length; i++)
                {
                    this.$items[i].style.transform = 'translateY(' + 0 + 'px) translateZ(0)'
                }
            }
            else
            {
                for(let i = 0; i < this.$items.length; i++)
                {
                    this.$items[i].style.height = 30 - this.$sublist[i].offsetHeight + 'px'
                }
            }
        },

        onToggleSublist(index, slug)
        {
            this.activeSublistIndex = index // === this.activeSublistIndex ? -1 : index

            this.onDisplayCat(slug)


            this.deployList(index)

            if(this.$route.name !== 'home')
            {
                this.$router.push('/')
            }
            else
            {
                this.eventHub.$emit('toggle:mobileNav')
            }
        },

        deployList(index)
        {
            if(!this.$root.isSmallScreen)
            {
                for(let i = 0; i < this.$items.length; i++)
                {
                    if(i === this.activeSublistIndex)
                    {
                        this.$items[index].style.transform = 'translateY(' + (-this.$items[this.activeSublistIndex].offsetHeight + 30) + 'px) translateZ(0)'
                    }
                    else if(i < this.activeSublistIndex)
                    {
                        this.$items[i].style.transform = 'translateY(' + (-this.$items[this.activeSublistIndex].offsetHeight + 30) + 'px) translateZ(0)'
                    }
                    else
                    {
                        this.$items[i].style.transform = 'translateY(' + 0 + 'px) translateZ(0)'
                    }

                }
            }
            else
            {
                for(let i = 0; i < this.$items.length; i++)
                {
                    if(i === this.activeSublistIndex)
                    {
                        this.$items[i].style.height = this.$items[i].offsetHeight + this.$sublist[i].offsetHeight + 'px'
                    }
                    else
                    {
                        this.$items[i].style.height = this.$items[i].offsetHeight - this.$sublist[i].offsetHeight + 'px'
                    }
                }
            }
        },

        onSublistActive(index, height)
        {
            this.activeSublistIndex = index
            this.activeSublistHeight = height
        },

        sortFilters(array)
        {
           const newArr = []

            array.forEach((l)  =>
            {
                l.isActive = true

                let isInArray = false

                for(let i = 0; i < newArr.length; i++)
                {


                    if(newArr[i].cat_ID === l.cat_ID)
                    {
                        newArr[i].count += 1
                        isInArray = true
                    }
                }

                if(!isInArray)
                {
                    l.count = 0

                    newArr.push(l)
                }
            })

            return newArr
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-filters/script.js